module.exports = __webpack_public_path__ + "static/media/fenxiang1.35a8372a.png";